import React from "react";
import styled from "styled-components";
import { createPortal } from "react-dom";
import { Close } from "../../assets/icons";

export const Modal = ({ isVisible, toggle, closable, children }) => {
	return (
		isVisible &&
		createPortal(
			<Container>
				<ModalMain>
					{closable && (
						<ModalCloseButton>
							<Close
								onClick={() => {
									toggle();
								}}
							/>
						</ModalCloseButton>
					)}

					{children}
				</ModalMain>
			</Container>,
			document.querySelector("#modal-root")
		)
	);
};

const Container = styled.div`
	position: fixed;
	top: 0;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	width: 100vw;
	height: 100vh;
	margin: 0;
	padding: 0;
	background: rgba(102, 102, 102, 0.4) 0% 0% no-repeat padding-box;

	z-index: 999999;
`;

const ModalMain = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	padding: 0.7rem 1.5rem;
	border-radius: 0;
	background: rgba(3, 0, 168, 0.1) 0% 0% no-repeat padding-box;
`;

const ModalCloseButton = styled.div`
	cursor: pointer;
	align-self: flex-end;
	padding: 16px;
	padding-bottom: 0;

	svg {
		fill: white;
	}
`;
